import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { AuthProvider } from './context/AuthContext';
import theme from './styles/theme';
import GlobalStyles from './styles/GlobalStyles';
import Navigation from './components/Navigation/Navigation';

// Lazy load pages for better performance
const HomePage = React.lazy(() => import('./pages/Home/HomePage'));
const LoginPage = React.lazy(() => import('./pages/Auth/LoginPage'));
const RequestAccessPage = React.lazy(() => import('./pages/Auth/RequestAccessPage'));
const PasswordRecoveryPage = React.lazy(() => import('./pages/Auth/PasswordRecoveryPage'));
const AccountPage = React.lazy(() => import('./pages/Account/AccountPage'));
const BriefHistoryPage = React.lazy(() => import('./pages/BriefHistory/BriefHistoryPage'));
const FamilyTreePage = React.lazy(() => import('./pages/FamilyTree/FamilyTreePage'));
const FamilyConnectionsPage = React.lazy(() => import('./pages/FamilyConnections/FamilyConnectionsPage'));
const ProudServicePage = React.lazy(() => import('./pages/ProudService/ProudServicePage'));
const ResourcesPage = React.lazy(() => import('./pages/Resources/ResourcesPage'));
const ContactPage = React.lazy(() => import('./pages/Contact/ContactPage'));

const LoadingFallback = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '100vh' 
  }}>
    Loading...
  </div>
);

const AppContent: React.FC = () => {
  return (
    <>
      <Navigation />
      <React.Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/request-access" element={<RequestAccessPage />} />
          <Route path="/password-recovery" element={<PasswordRecoveryPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/brief-history" element={<BriefHistoryPage />} />
          <Route path="/family-tree" element={<FamilyTreePage />} />
          <Route path="/family-connections" element={<FamilyConnectionsPage />} />
          <Route path="/proud-service" element={<ProudServicePage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </React.Suspense>
    </>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <GlobalStyles />
          <AppContent />
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
};

export default App;